export default "__VITE_ASSET__D8ziGhG8__"